import { render } from "./login-content.vue?vue&type=template&id=6da82e9c&ts=true"
import script from "./login-content.vue?vue&type=script&lang=ts"
export * from "./login-content.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__